import { mapGetters } from "vuex";

export default {
    name: "PigmentCodeProgram",
    props: {},
    emits: [],
    components: {},
    setup() {},
    data() {
        return {}
    },
    created() {},
    mounted() {},
    watch: {},
    computed: {
      ...mapGetters({
        content: "pigmentCode/content",
      })
    },
    methods: {
      parseText(text) {
        let response = {
          name: '',
          text: ''
        }
        const div = document.createElement("div");
        div.innerHTML = text;

        const name = div.querySelector('b');
        if (name) {
          response.name = name.textContent;
          const otherText = div.innerHTML.replace(`<b>${name.textContent}</b>`, '');
          response.text = otherText.trim();
        }

        return response
      },
      scroll() {
        const element = document.querySelector(".pigment-code__format--title")
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
            inline: "nearest",
            offset: { top: 30 }
          })
        }
      }
    }
}
